import { PROJCOMP, ADR_EDIT } from "../_constants/actionConstants";
import axios from "axios";
import { getUUID } from "../_utils/generalUtils";
import { BASE_URL } from "../_constants/urlConstants";
import { actionScripts } from "../_helpers/actionScripts";

const addKeyword = (newKeywordData) => (dispatch) =>
  new Promise((resolve) => {
    dispatch({ type: PROJCOMP.ADD_KEYWORD });
    const apiEndpoint = BASE_URL + "/api/ProjectAdmin/AddProjectKeyword";
    axios
      .post(apiEndpoint, newKeywordData)
      .then((response) => {
        dispatch({
          type: PROJCOMP.ADD_KEYWORD_FULFILLED,
          projKeywordList: response.data.projKeywordList,
          projectId: newKeywordData.projectId,
        });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PROJCOMP.ADD_KEYWORD_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.log(PROJCOMP.ADD_KEYWORD_REJECTED, err.response.data);
      });
  });

const editKeyword = (updatedKeyword) => (dispatch) =>
  new Promise((resolve) => {
    dispatch({ type: PROJCOMP.EDIT_KEYWORD });
    const apiEndpoint = BASE_URL + "/api/ProjectAdmin/UpdateKeyword";
    axios
      .post(apiEndpoint, updatedKeyword)
      .then((response) => {
        dispatch({
          type: PROJCOMP.EDIT_KEYWORD_FULFILLED,
          projKeywordList: response.data.projKeywordList,
          projectId: updatedKeyword.projectId,
        });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PROJCOMP.EDIT_KEYWORD_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.log(PROJCOMP.EDIT_KEYWORD_REJECTED, err.response.data);
      });
  });

const deleteKeyword = (kwData) => (dispatch) =>
  new Promise((resolve) => {
    dispatch({ type: PROJCOMP.DELETE_KEYWORD });
    const apiEndpoint = BASE_URL + "/api/ProjectAdmin/DeleteKeyword";
    axios
      .post(apiEndpoint, kwData)
      .then((response) => {
        dispatch({
          type: PROJCOMP.DELETE_KEYWORD_FULFILLED,
          projKeywordList: response.data.projKeywordList,
          projectId: kwData.projectId,
        });
        resolve();
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PROJCOMP.DELETE_KEYWORD_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.log(PROJCOMP.DELETE_KEYWORD_REJECTED, err.response.data);
      });
  });

const keywordHasLinks = (projId, kwId) => (dispatch) =>
  new Promise((resolve) => {
    dispatch({ type: PROJCOMP.KEYWORD_HAS_LINKS });
    const apiEndpoint = BASE_URL + "/api/ProjectAdmin/KeywordHasLinks";
    axios
      .get(apiEndpoint, { params: { projId, kwId } })
      .then((response) => {
        dispatch({ type: PROJCOMP.KEYWORD_HAS_LINKS_FULFILLED });
        resolve(response.data);
      })
      .catch((err) => {
        const errorId = getUUID();
        const type = PROJCOMP.KEYWORD_HAS_LINKS_REJECTED;
        const newError = { errorId, type, error: err.response.data };
        actionScripts.ADD_ERROR.run(newError);
        console.log(PROJCOMP.KEYWORD_HAS_LINKS_REJECTED, err.response.data);
      });
  });

const fetchWorkDayNumber = (date, isFiveDayWorkingCalendar, tabId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: PROJCOMP.FETCH_WORKDAY_NUMBER });
    let formateDate = new Date(`${date}`);
    const apiEndpoint = `/api/ProjectAdmin/GetWorkdayNumber/?date=${formateDate.toLocaleDateString()}&isFiveDayWorkingCalendar=${isFiveDayWorkingCalendar}`;
    axios
      .get(apiEndpoint)
      .then((response) => {
        let reportNo = isNaN(response.data) ? response.data.split(".")[0] : response.data;
        let reportNoSuffix = isNaN(response.data) ? response.data.split(".")[1] : "";
        dispatch({
          type: PROJCOMP.FETCH_WORKDAY_NUMBER_FULFILLED,
          tabId,
          workdayNumber: response.data,
        });
        resolve({
          reportNo,
          reportNoSuffix,
        });

        // return {
        //   reportNo: reportNo,
        //   reportNoSuffix: reportNoSuffix,
        // };
      })
      .catch((err) => {
        const errorId = getUUID();
        console.log(
          PROJCOMP.FETCH_WORKDAY_NUMBER_REJECTED,
          err && err.response && err.response.data
        );
      });
  });

const projCompActions = {
  addKeyword,
  editKeyword,
  deleteKeyword,
  keywordHasLinks,
  fetchWorkDayNumber,
};

export default projCompActions;
